import React from 'react';
import Button from 'components/button';
import { useFormikContext } from 'formik';

function FormButton(props) {
  const { isSubmitting } = useFormikContext();

  return <Button {...props} disabled={isSubmitting || props.disabled} />;
}

export default FormButton;
